export enum InvoiceCatTipoDeComprobante {
  'Ingreso' = 'I',
  'Egreso' = 'E',
  'Traslado' = 'T',
  'Nómina' = 'N',
  'Pago' = 'P',
}
